import { render, staticRenderFns } from "./MoreDetail.vue?vue&type=template&id=f42b01fe&scoped=true"
import script from "./MoreDetail.vue?vue&type=script&lang=js"
export * from "./MoreDetail.vue?vue&type=script&lang=js"
import style0 from "./MoreDetail.vue?vue&type=style&index=0&id=f42b01fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42b01fe",
  null
  
)

export default component.exports